import { v4 as uuidv4 } from 'uuid'

export const getInitialArticlesItemData = () => ({
  article: {},
  clientId: uuidv4(),
})
